import { Injectable } from '@angular/core';
import swal from 'sweetalert2';
import { AlertOptions } from './alert-options';
import { AlertTypeEnum } from './alert-type-enum';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    constructor() { }

    alert(title: string, text: string, confirmButtonText: string = 'Ok', tipus?: AlertTypeEnum,  html: string = null): Promise<any> {

        const options = new AlertOptions();
        options.confirmButtonText = confirmButtonText;
        options.title = title;
        options.icon = tipus || AlertTypeEnum.success;

        if (html) {
            options.html = html;
        } else {
            options.text = text;
        }

        return swal.fire(options);
    }

    confirm(title: string, text: string, confirmButtonText: string = 'Ok', cancelButtonText: string = 'Cancel', html: string = null): Promise<any> {
        const options = new AlertOptions();
        options.confirmButtonText = confirmButtonText;
        options.cancelButtonText = cancelButtonText;
        options.icon = AlertTypeEnum.question;
        options.showCancelButton = true;
        options.title = title;

        if (html) {
            options.html = html;
        } else {
            options.text = text;
        }
        return this.alertOptions(options);
    }

    alertOptions(options: AlertOptions): Promise<any> {
        return swal.fire(options);
    }
}
